import { initSentry } from './sentry';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import Deploying from 'screen/Deploying';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import './styles/summary-components.scss'; // also include import './styles/custom.scss';
import './styles/mobile-responsive.scss';
import { createTheme, ThemeProvider } from '@mui/material';
import { ToastProvider } from 'react-toast-notifications';
import { Toaster } from 'react-hot-toast';
import ModalPassword from 'screen/ModalPassword';
import CamUpgradeModalHost from 'components/CamUpgradeModalHost';
import { ConfirmProvider } from 'material-ui-confirm';
import { ErrorBoundary } from 'screen/Error';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CssVarsProvider } from '@mui/joy/styles';

initSentry();

const isDeploying = String(process.env.REACT_APP_DEPLOYING || '').toLowerCase() === 'true';

const theme = createTheme({
  typography: {
    body1: {
      fontWeight: 500,
    },
    fontFamily: ['Manrope', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    primary: { main: '#4D88F0' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
        }
      `,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    {isDeploying ? (
      <Deploying />
    ) : (
      <CssVarsProvider>
        <ErrorBoundary>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
            <Provider store={store}>
              <ThemeProvider theme={theme}>
                <ConfirmProvider>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <ToastProvider autoDismiss autoDismissTimeout={3500} placement="top-right">
                      <div>
                        <Toaster position="top-right" reverseOrder={false} />
                      </div>
                      {process.env.REACT_APP_ENV !== 'production' && <ModalPassword />}
                      <CamUpgradeModalHost />
                      <App />
                    </ToastProvider>
                  </LocalizationProvider>
                </ConfirmProvider>
              </ThemeProvider>
            </Provider>
          </GoogleOAuthProvider>
        </ErrorBoundary>
      </CssVarsProvider>
    )}
    <script
      type="text/javascript"
      src="https://api.useberry.com/integrations/liveUrl/scripts/useberryScript.js"
    ></script>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
